import React from "react";
import { Link } from "react-router-dom";
import { Heart, HandHeart, Users, Megaphone, Building2, Package, Share2, Gift } from "lucide-react";
import { useI18n } from "../context/I18nContext";

const icons = [Heart, HandHeart, Users, Megaphone, Building2, Package, Share2, Gift];
const routes = ["/faire-un-don","/entreprises-partenaires","/devenir-benevole","/devenir-ambassadeur","/entreprises-partenaires","/contact","/contact","/contact"];

export default function Support() {
  const { t } = useI18n();
  const opts = t("support.opts") || [];
  return (
    <div data-testid="support-page">
      <section className="hero-gradient py-24">
        <div className="max-w-6xl mx-auto px-5 lg:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-warm-orange font-semibold">{t("pages.support.tag")}</div>
          <h1 className="font-display text-deep-blue text-5xl sm:text-6xl lg:text-7xl leading-tight mt-3">{t("pages.support.t1")}<br/><span className="italic text-warm-orange">{t("pages.support.t2")}</span></h1>
        </div>
      </section>
      <section className="py-16 bg-ivory">
        <div className="max-w-6xl mx-auto px-5 lg:px-10 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {opts.map((o, i) => {
            const Icon = icons[i] || Heart;
            return (
              <Link to={routes[i]} key={o.title} className="card-elev rounded-2xl p-6 group" data-testid={`support-opt-${i}`}>
                <Icon className="text-warm-orange" size={26}/>
                <h3 className="font-display text-xl text-deep-blue mt-3">{o.title}</h3>
                <p className="text-sm text-deep-blue/60 mt-2">{o.desc}</p>
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}
